import { apiWrapper } from "apis/CommonApi";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as accountApi from "../apis/AccountApi";

export default function FindPasswordPage() {
  return (
    <div id="wrap">
      <Main />
    </div>
  );
}

function Main() {
  return (
    <main id="main" className="main">
      <HeadSection />
      <JoinSection />
    </main>
  );
}

function HeadSection() {
  return (
    <section class="headSection">
      <div class="container cont-960">
        <div class="wrap_head">
          <div class="wrap_title wrap_txt_title">
            <Link class="logo bold" to="/">LOGO</Link>
            <span class="bar"></span>
            <p class="title">가입하신 회원 정보와 일치할 경우 <br class="mb" /> 이메일로 패스워드를 발송 드립니다</p>
          </div>
        </div>
      </div>
    </section>
  );
}

function JoinSection() {
  const [formData, setFormData] = useState(null);

  useEffect(() => {
    setFormDataProperty("userId", "");
    setFormDataProperty("phoneNumber1", "");
    setFormDataProperty("phoneNumber2", "");
    setFormDataProperty("phoneNumber3", "");
    setFormDataProperty("email", "");
  }, []);

  const setFormDataProperty = (name, value) => {
    setFormData((currentFormData) => {
      const nextFormData = {
        ...currentFormData,
        [name]: value,
      };
      //console.log(nextFormData);
      return nextFormData;
    });
  };

  const onChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setFormDataProperty(name, value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
    } else {
      apiWrapper(async () => {
        const { userId, phoneNumber1, phoneNumber2, phoneNumber3, email } = formData;
        const phoneNumber = `${phoneNumber1}${phoneNumber2}${phoneNumber3}`;
        const { status, data } = await accountApi.findPassword(userId, phoneNumber, email);
        if (data) {
          alert(`${data}`);
        }
      });
    }
  }

  return (
    <section class="joinSection">
      <div class="container cont-960">
        <form onSubmit={handleSubmit}>
          {formData && (
            <div class="whiteBoard wrap_findId">
              <button class="btn_prev">
                <i class="x-icon icon_prev"></i>
              </button>
              <p class="title_whiteBoard">패스워드 찾기</p>
              <div class="wrap_input">
                <div class="item_input">
                  <p class="title_item">아이디</p>
                  <input type="text" class="defaultInput" name="userId" value={formData.userId} onChange={onChange} required="required" />
                </div>
                <div class="item_input">
                  <p class="title_item">휴대폰 번호</p>
                  <div class="wrap_inner type2">
                    <div class="wrap_enter">
                      <input type="number" class="defaultInput" name="phoneNumber1" value={formData.phoneNumber1} onChange={onChange} required="required" />
                      <input type="number" class="defaultInput" name="phoneNumber2" value={formData.phoneNumber2} onChange={onChange} required="required" />
                      <input type="number" class="defaultInput" name="phoneNumber3" value={formData.phoneNumber3} onChange={onChange} required="required" />
                    </div>
                  </div>
                </div>
                <div class="item_input">
                  <p class="title_item">이메일 주소</p>
                  <input type="email" class="defaultInput" name="email" value={formData.email} onChange={onChange} required="required" />
                </div>
              </div>
              <button class="btn_orange btn_findId" type="submit">패스워드 찾기</button>
            </div>
          )}
        </form>
      </div>
    </section>
  );
}
